import decode from "jwt-decode";

export default class User {
  Permissions = [];
  clientes = [];
  constructor(token, expires, perfil, clienteId, clienteNome) {
    const jwt = decode(token);
    this.token = token;
    this.expires = expires;
    this.iss = jwt.iss;
    if (jwt.iss.includes("microsoft")) {
      this.nome = jwt.name;
      this.email = jwt.preferred_username;
      this.perfil = perfil;
      this.clienteId = clienteId;
      this.clienteNome = clienteNome;
    } else {
      this.nome = jwt.nome;
      this.email = jwt.email;
      this.perfil = jwt.perfil;
      this.clienteId = jwt.clienteId;
      this.clienteNome = jwt.clienteNome;
    }
  }

  // constructor(token, expires, refreshToken) {
  //   const jwt = decode(token);
  //   this.token = token;
  //   this.expires = expires;
  //   this.refreshToken = refreshToken;
  //   this.nome = jwt.nome;
  //   this.email = jwt.email;
  //   this.perfil = jwt.perfil;
  //   this.consultorId = jwt.consultorId;
  //   this.Permissions = jwt.Permissions.split(",");
  // }
}
